import { ApiProperty } from "@nestjs/swagger";

export class StyleReqDto {
    @ApiProperty()
    styleNo?: string[]
     @ApiProperty()
     season?: string;
     @ApiProperty()
     year?: string;
     @ApiProperty()
     styleId?: number;
    }

